export default "__VITE_ASSET__bWx52tSs__"